var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-upload"},[_c('div',{on:{"click":_vm.bindUpload}},[_vm._v("上传图片")])])}
var staticRenderFns = []

export { render, staticRenderFns }